
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../../../../shared/services/common.service';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { HttpClient } from '@angular/common/http';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import saveAs from 'file-saver';
import * as XLSX from 'xlsx';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, switchMap } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { IARegisterDashboard, MsMeRegisterByIaInterest } from '../../../../../shared/models/IARegister';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-viewregistermsmebyiainterest',
  templateUrl: './viewregistermsmebyiainterest.component.html',
  styleUrl: './viewregistermsmebyiainterest.component.css'
})
export class ViewregistermsmebyiainterestComponent implements OnInit, OnDestroy {

  dataSource!: MatTableDataSource<MsMeRegisterByIaInterest>

  udyamRegistrationNumber?: string;
  email?: string;
  nameOfEnterprise?: string;
  ownersMobileNumber?: number;
  displayedColumns: string[] = ['Sr.No', 'udyamRegistrationNumber', 'email', 'nameOfEnterprise', 'ownersMobileNumber']

  Formloaded: boolean = false;

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';
  reportData: any[] = [];
  allrecord: any[] = [];

  IAUserId: any;
  uniqueEventId: any;
  items: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  page = 1;
  pageSize = 10;
  length: number = 0;
  DtoPagination =
    {
      "PageNumber": 1,
      "PageSize": 10,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": "" || null
    }
  searchCol: any;

  //DtoPagination =
  //  {
  //    "PageNumber": 1,
  //    "PageSize": 20,
  //    "SortColumn": "",
  //    "SortDirection": "",
  //    "SearchTerm": "",
  //    "SearchCol":""
  //  }


  //DtoPagination =
  //  {
  //    "UserId": sessionStorage.getItem("industryAssociationUserId"),
  //    "EventId": sessionStorage.getItem("uniqueEventId"),
  //    "PageNumber": 1,
  //    "PageSize": 10,
  //    "SortColumn": "",
  //    "SortDirection": "",
  //    "SearchTerm": ""
  //  }



  constructor(private common: CommonService, private router: Router,
    private toastr: ToastrService,
    private http: HttpClient,
    private apiService: ApiService,
    private toastrService: ToastrService) {
    this.searchCol = localStorage.getItem("searchCol")?.toString();
  }


  totalmsmeform = new FormGroup({
    searchControl: new FormControl('', [
      Validators.pattern(this.common.searchFilter)
    ])
  })

  ngOnInit(): void {

    this.DtoPagination.PageSize = 20;
    if (!this.searchCol) {
      localStorage.setItem("searchCol", this.common.searchText);
      this.searchCol = localStorage.getItem("searchCol")?.toString();
    }



    sessionStorage.getItem('onSpotUserId')
    //sessionStorage.getItem('uniqueeventid')
    /* this.DtoPagination.PageSize = 20;*/
    //this.loadAllrecord();
    if (!this.Formloaded) {
      //this.loadAllrecord();
      this.Formloaded = true;
    }
    // this.IAUserId = sessionStorage.getItem('industryAssociationUserId');
    // this.uniqueEventId = sessionStorage.getItem('uniqueEventId')
    //this.loadReport(this.DtoPagination);


  }

  ngAfterViewInit() {
    this.loadReport();
  }
  //ngOnInit(): void {
  //  sessionStorage.getItem('onSpotUserId')
  //  //sessionStorage.getItem('uniqueeventid')
  //  this.DtoPagination.PageSize = 20;
  //  //this.loadAllrecord();
  //  if (!this.Formloaded) {
  //    //this.loadAllrecord();
  //    this.Formloaded = true;
  //  }
  //  // this.IAUserId = sessionStorage.getItem('industryAssociationUserId');
  //  // this.uniqueEventId = sessionStorage.getItem('uniqueEventId')
  //  this.loadReport(this.DtoPagination);

  //}


  loadReport() {
    this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
    merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
      this.pagination.page)
      .pipe(filter(searchTerm => searchTerm != null),
        switchMap((searchTerm) => {
          if (searchTerm) {
            this.pagination.pageIndex = 0;
          }
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.searchCol;
          return this.apiService.getRequest(API_ENDPOINTS.IA.GETMSMEBYIAINTEREST, this.DtoPagination)
            .pipe(catchError(() => of(null)));

        }),
        map(resp => {
          if (resp.status) {
            this.length = resp['totalRecords'];
            //console.log(resp)
            //this.focusSectorDetails = resp.data; // Ensure this is correctly assigned
            // console.log("focus sector details:", this.focusSectorDetails)

          }
          return resp.data;

        })
      ).subscribe(data => {
        this.dataSource = new MatTableDataSource(data);
        //this.dataSource = data;
        this.adjustPaginator();

        // Reintroduce the logic to change button text to 'Submit'
        //this.FocusSectorForm.get('FocusSectorName')?.enable();
        //this.changeButtonText('Submit'); // Button Change to Submit


      });
  }



  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }


  //loadReport(DtoPagination:any): void {
  //  this.apiService.getRequest(API_ENDPOINTS.IA.GETTOTALONSPOTUSER, DtoPagination).subscribe(
  //    (data) => {
  //      this.length = data['totalRecords']
  //      this.reportData = data.data;


  //    },
  //    (error: any) => {
  //      console.error('Error fetching report data:', error);
  //    }
  //  );
  //}

  loadAllrecord() {
    const DtonullPagination = {
      //EventId: sessionStorage.getItem("uniqueEventId"),
      PageNumber: 1,    // or undefined
      PageSize: 9999999,      // or undefined
      SortColumn: "",  // example sort column
      SortDirection: "", // example sort direction
      SearchTerm: "",   // optional search term
      "SearchCol": ""
    };
    this.apiService.getRequest(API_ENDPOINTS.IA.GETMSMEBYIAINTEREST, DtonullPagination).subscribe(
      (data) => {
        this.length = data['totalRecords']
        this.allrecord = data.data;
        //console.log(this.allrecord)

      },
      (error: any) => {
        console.error('Error fetching report data:', error);
      }
    );

  }

  
  

 

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  onPageChange(e: PageEvent) {

    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadReport();
  }

  onSearchChange(event: Event): void {
    this.totalmsmeform.get('searchControl')?.markAsTouched();
    const searchValue = (event.target as HTMLInputElement).value;
    if (this.totalmsmeform.get('searchControl')?.valid) {
      this.DtoPagination.SearchTerm = searchValue;
      this.loadReport(); // Fetch filtered data
    }
  }


  onSearchClick(searchValue: string): void {
    const searchControl = this.totalmsmeform.get('searchControl');
    searchControl?.markAsTouched(); // Mark the control as touched for validation feedback

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.loadReport(); // Fetch filtered data
      //console.log('Search triggered with value:', searchValue);
    } else if (searchValue.trim() === '') {
      console.error('Search term is empty');
    } else {
      console.error('Invalid search term');
    }
  }
  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.searchCol;
    this.loadReport();
  }

  exportToExcel(): void {
    const fileName = 'Msme_User_List.xlsx';

    const DtoPagination = {
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: this.searchCol,
    };

    this.apiService.getRequest(API_ENDPOINTS.IA.GETMSMEBYIAINTEREST, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data;

          if (!this.allrecord || this.allrecord.length === 0) {
            this.toastr.error('No data available to export.');
            return;
          }

          const excelData = this.allrecord.map((item, index) => ({
            'Sr.No': item.RowNum,
            'Udyam Number': item.udyamRegistrationNumber,
            'Email': item.email,
            'Name Of Enterprise': item.nameOfEnterprise,
            'Mobile Number': item.ownersMobileNumber,
            

          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          const columnWidths = [
            { wch: 10 }, // Sr.No            
            { wch: 30 }, // Event Focus Sector Type
            { wch: 30 }, // Event Focus Sector Name
          ];
          worksheet['!cols'] = columnWidths;

          const workbook: XLSX.WorkBook = {
            Sheets: { 'MsMe User List': worksheet },
            SheetNames: ['MsMe User List'],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });

          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastr.success('Excel exported successfully!');
        }
      }
    );
  }



  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

  ngOnDestroy() {
    localStorage.clear();
  }

}


